module.exports = __webpack_public_path__ + "static/media/hammer.488ab58a.svg";